import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { AppInjector } from './app/shared/services/app-injector.service';

if (environment.production) {
  enableProdMode();
}

// CINX-148: the Mercado Pago OAuth consent runs in a popup so the Payment token screen (the opener)
// never navigates away and keeps its session. When Mercado Pago redirects the popup back to
// /payment-token with ?code&state (or ?error), hand the result to the opener and close — without
// booting the app in the popup. Runs before bootstrap so no guard/router can drop the params.
function relayMercadoPagoPopupResult(): boolean {
  try {
    const params = new URLSearchParams(window.location.search);
    if (!window.opener
      || !window.location.pathname.endsWith('/payment-token')
      || !(params.has('code') || params.has('error'))) {
      return false;
    }
    (window.opener as Window).postMessage({
      type: 'mpOauthCallback',
      code: params.get('code'),
      state: params.get('state'),
      error: params.get('error'),
    }, window.location.origin);
    window.close();
    return true;
  } catch (e) {
    console.error('[payment-token] failed relaying OAuth popup result to opener', e);
    return false;
  }
}

if (!relayMercadoPagoPopupResult()) {
  platformBrowserDynamic().bootstrapModule(AppModule).then((moduleRef) => {
    AppInjector.setInjector(moduleRef.injector);
    return Promise.resolve(moduleRef);
  }).catch(err => console.error(err));
}
